<template>
    <div id="login_comp">
        <section class="content">
            <app-menu v-if="isLoggedIn"></app-menu>
            <div class="container-fluid">
                <div class="row clearfix">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="login-register-top">
                                <div class="login-register-top-block">
                                    <p>
                                        <strong>View Contact</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'CaseCreate',
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/contact/viewContact.vue